(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hundetips-hvor-mye-vann"] && !Shopify.designMode) return;
  try {
    
(function() {
  const weightEl = document.getElementById('mh-wc-weight');
  if (!weightEl) return;

  const weightOut = document.getElementById('mh-wc-weight-out');
  const breedEl = document.getElementById('mh-wc-breed');
  const activityEl = document.getElementById('mh-wc-activity');
  const foodEl = document.getElementById('mh-wc-food');
  const weatherEl = document.getElementById('mh-wc-weather');
  const puppyEl = document.getElementById('mh-wc-puppy');
  const nursingEl = document.getElementById('mh-wc-nursing');
  const seniorEl = document.getElementById('mh-wc-senior');
  const resultMl = document.getElementById('mh-wc-result-ml');
  const resultLiters = document.getElementById('mh-wc-result-liters');
  const resultTip = document.getElementById('mh-wc-result-tip');

  function calculate() {
    const weight = parseFloat(weightEl.value);
    const activity = parseFloat(activityEl.value);
    const food = parseFloat(foodEl.value);
    const weather = parseFloat(weatherEl.value);

    // Holdes innenfor 40–60 ml/kg-spennet som prosaen og vektklasse-tabellen oppgir.
    // Små hunder ligger i øvre del av spennet, store i nedre — men aldri utenfor det.
    let basePerKg = 55;
    if (weight < 5) basePerKg = 60;
    else if (weight < 10) basePerKg = 58;
    else if (weight < 25) basePerKg = 55;
    else basePerKg = 52;

    let total = weight * basePerKg * activity * food * weather;
    const tips = [];

    if (puppyEl.checked) {
      total *= 1.5;
      tips.push('Valper dehydrerer raskt — fri tilgang til vann hele døgnet.');
    }
    if (nursingEl.checked) {
      total *= 1.8;
      tips.push('Drektig eller ammende tispe har kraftig økt behov.');
    }
    if (seniorEl.checked) {
      total *= 1.05;
      tips.push('Senior — følg med på drikkemønsteret, det kan endre seg.');
    }
    if (weather === 1.6) tips.push('Varmt vær: tilby vann hver time på tur.');
    if (activity >= 1.3) tips.push('Høy aktivitet: små mengder flere ganger framfor én stor slurk.');

    total = Math.round(total);
    const liters = (total / 1000).toFixed(2).replace('.', ',');

    resultMl.textContent = total.toLocaleString('nb-NO') + ' ml';
    resultLiters.textContent = liters + ' liter';

    if (tips.length === 0) {
      resultTip.textContent = 'Normalt behov for frisk, voksen hund.';
    } else {
      resultTip.textContent = tips.join(' ');
    }
  }

  weightEl.addEventListener('input', () => {
    weightOut.textContent = weightEl.value + ' kg';
    calculate();
  });

  breedEl.addEventListener('change', () => {
    if (breedEl.value) {
      weightEl.value = breedEl.value;
      weightOut.textContent = breedEl.value + ' kg';
      calculate();
    }
  });

  [activityEl, foodEl, weatherEl, puppyEl, nursingEl, seniorEl].forEach(el => {
    el.addEventListener('change', calculate);
  });

  calculate();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
